export const COLORS = [
  "hsl(210, 100%, 60%)", // Bright Blue
  "hsl(120, 70%, 50%)", // Bright Green
  "hsl(0, 85%, 60%)", // Bright Red
  "hsl(45, 100%, 55%)", // Golden Yellow
  "hsl(280, 85%, 65%)", // Purple
  "hsl(20, 90%, 60%)", // Orange
  "hsl(180, 70%, 50%)", // Cyan
  "hsl(300, 80%, 65%)", // Magenta
  "hsl(90, 65%, 55%)", // Lime Green
  "hsl(330, 75%, 65%)", // Pink
  "hsl(200, 80%, 60%)", // Sky Blue
  "hsl(60, 85%, 60%)", // Yellow Green
  "hsl(15, 85%, 65%)", // Coral
  "hsl(270, 70%, 60%)", // Violet
  "hsl(150, 75%, 55%)", // Sea Green
  "hsl(320, 80%, 60%)", // Hot Pink
  "hsl(40, 90%, 60%)", // Amber
  "hsl(190, 75%, 55%)", // Turquoise
  "hsl(260, 75%, 65%)", // Blue Violet
  "hsl(100, 60%, 55%)", // Yellow Green
  "hsl(350, 80%, 60%)", // Rose
  "hsl(170, 70%, 50%)", // Teal
  "hsl(50, 80%, 60%)", // Gold
  "hsl(220, 85%, 65%)", // Royal Blue
  "hsl(110, 65%, 55%)", // Bright Lime
  "hsl(340, 75%, 60%)", // Deep Pink
  "hsl(25, 85%, 60%)", // Orange Red
  "hsl(140, 70%, 50%)", // Green
]
